<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Drukarki C2326, C3224, C3326, C3426, CS331, CS431, CS439">
     Drukarki C2326, C3224, C3326, C3426, CS331, CS431, CS439
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_pl" title="Informacje dotyczące bezpieczeństwa">
     Informacje dotyczące bezpieczeństwa
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Definicje pojęć">
      Definicje pojęć
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Informacje dotyczące produktu">
      Informacje dotyczące produktu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_pl" title="Informacje dotyczące drukarki">
     Informacje dotyczące drukarki
    </a>
   </p>
   <div id="divd0e173">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_pl" title="Znajdowanie informacji na temat drukarki">
      Znajdowanie informacji na temat drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_pl" title="Odnajdywanie numeru seryjnego drukarki">
      Odnajdywanie numeru seryjnego drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_pl" title="Wyposażenie drukarki">
      Wyposażenie drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_pl" title="Korzystanie z&nbsp;panelu sterowania">
      Korzystanie z&nbsp;panelu sterowania
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_pl" title="Dostosowywanie ekranu gł&oacute;wnego">
      Dostosowywanie ekranu gł&oacute;wnego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_pl" title="Opis stan&oacute;w kontrolki">
      Opis stan&oacute;w kontrolki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e627" title="Wyb&oacute;r papieru">
      Wyb&oacute;r papieru
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_pl" title="Przygotowanie, instalacja i konfiguracja">
     Przygotowanie, instalacja i konfiguracja
    </a>
   </p>
   <div id="divd0e1351">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_pl" title="Wyb&oacute;r miejsca na drukarkę">
      Wyb&oacute;r miejsca na drukarkę
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_pl" title="Podłączanie kabli">
      Podłączanie kabli
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-trays-topic.html#installing-optional-trays_pl" title="Instalowanie opcjonalnych tac">
      Instalowanie opcjonalnych tac
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#d0e1549" title="Konfigurowanie i używanie aplikacji na ekranie gł&oacute;wnym">
      Konfigurowanie i używanie aplikacji na ekranie gł&oacute;wnym
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e1676" title="Ładowanie papieru i nośnik&oacute;w specjalnych">
      Ładowanie papieru i nośnik&oacute;w specjalnych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e1851" title="Instalacja i aktualizacja oprogramowania, sterownik&oacute;w oraz oprogramowania sprzętowego">
      Instalacja i aktualizacja oprogramowania, sterownik&oacute;w oraz oprogramowania sprzętowego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e2111" title="Sieć">
      Sieć
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_pl" title="Drukowanie strony ustawień menu">
      Drukowanie strony ustawień menu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="secure-printer-chapter.html#secure-printer-chapter_pl" title="Zabezpieczanie drukarki">
     Zabezpieczanie drukarki
    </a>
   </p>
   <div id="divd0e2556">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_pl" title="Czyszczenie pamięci drukarki">
      Czyszczenie pamięci drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_pl" title="Przywracanie ustawień fabrycznych">
      Przywracanie ustawień fabrycznych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_pl" title="Informacje o ulotności pamięci">
      Informacje o ulotności pamięci
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_pl" title="Drukowanie">
     Drukowanie
    </a>
   </p>
   <div id="divd0e2678">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_pl" title="Drukowanie z komputera">
      Drukowanie z komputera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2704" title="Drukowanie z urządzenia przenośnego">
      Drukowanie z urządzenia przenośnego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_pl" title="Konfiguracja poufnych zadań">
      Konfiguracja poufnych zadań
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_pl" title="Drukowanie zadań poufnych i innych zadań wstrzymanych">
      Drukowanie zadań poufnych i innych zadań wstrzymanych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_pl" title="Drukowanie za pomocą profilu Cloud Connector">
      Drukowanie za pomocą profilu Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-lis_pl" title="Drukowanie listy wzorc&oacute;w czcionek">
      Drukowanie listy wzorc&oacute;w czcionek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_pl" title="Umieszczanie arkuszy separujących między kopiami">
      Umieszczanie arkuszy separujących między kopiami
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_pl" title="Anulowanie zadania drukowania">
      Anulowanie zadania drukowania
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_pl" title="Regulowanie intensywności tonera">
      Regulowanie intensywności tonera
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_pl" title="Używanie menu drukarki">
     Używanie menu drukarki
    </a>
   </p>
   <div id="divd0e3246">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_pl" title="Mapa menu">
      Mapa menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3503" title="Urządzenie">
      Urządzenie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e4995" title="Drukowanie">
      Drukowanie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e5943" title="Papier">
      Papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6183" title="Sieć/porty">
      Sieć/porty
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8173" title="Bezpieczeństwo">
      Bezpieczeństwo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_pl" title="Cloud Connector">
      Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e8829" title="Raporty">
      Raporty
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_pl" title="Rozwiązywanie problem&oacute;w">
      Rozwiązywanie problem&oacute;w
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_pl" title="Konserwacja drukarki">
     Konserwacja drukarki
    </a>
   </p>
   <div id="divd0e9032">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_pl" title="Sprawdzanie stanu części i materiał&oacute;w eksploatacyjnych">
      Sprawdzanie stanu części i materiał&oacute;w eksploatacyjnych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_pl" title="Konfigurowanie powiadomień dotyczących materiał&oacute;w eksploatacyjnych">
      Konfigurowanie powiadomień dotyczących materiał&oacute;w eksploatacyjnych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_pl" title="Konfigurowanie alarm&oacute;w e-mail">
      Konfigurowanie alarm&oacute;w e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_pl" title="Oglądanie raport&oacute;w">
      Oglądanie raport&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_pl" title="Zamawianie części i materiał&oacute;w eksploatacyjnych">
      Zamawianie części i materiał&oacute;w eksploatacyjnych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-print-cartridge-topic.html#d0e9851" title="Wymiana części i materiał&oacute;w eksploatacyjnych">
      Wymiana części i materiał&oacute;w eksploatacyjnych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e10049" title="Czyszczenie części drukarki">
      Czyszczenie części drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e10170" title="Oszczędzanie energii i papieru">
      Oszczędzanie energii i papieru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_pl" title="Przenoszenie drukarki w inne miejsce">
      Przenoszenie drukarki w inne miejsce
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_pl" title="Transport drukarki">
      Transport drukarki
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_pl" title="Rozwiązywanie problemu">
     Rozwiązywanie problemu
    </a>
   </p>
   <div id="divd0e10331">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_pl" title="Problemy z jakością wydruku">
      Problemy z jakością wydruku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e10431" title="Problemy z drukowaniem">
      Problemy z drukowaniem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_pl" title="Drukarka nie odpowiada">
      Drukarka nie odpowiada
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e12836" title="Problemy z połączeniem sieciowym">
      Problemy z połączeniem sieciowym
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e13055" title="Problemy z materiałami eksploatacyjnymi">
      Problemy z materiałami eksploatacyjnymi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_pl" title="Usuwanie zacięć">
      Usuwanie zacięć
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e13492" title="Problemy z podawaniem papieru">
      Problemy z podawaniem papieru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e13874" title="Problemy z jakością koloru">
      Problemy z jakością koloru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_pl" title="Kontakt z obsługą klienta">
      Kontakt z obsługą klienta
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_pl" title="Recykling i utylizacja">
     Recykling i utylizacja
    </a>
   </p>
   <div id="divd0e14113">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_pl" title="Recykling produkt&oacute;w Lexmark">
      Recykling produkt&oacute;w Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_pl" title="Recykling opakowań firmy Lexmark">
      Recykling opakowań firmy Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_pl" title="Uwagi">
     Uwagi
    </a>
   </p>
   <div id="divd0e14148">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14151" title="Informacje o produkcie">
      Informacje o produkcie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14168" title="Informacje o wydaniu">
      Informacje o wydaniu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_pl" title="Znaki towarowe">
      Znaki towarowe
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_pl" title="Oświadczenia dotyczące licencji">
      Oświadczenia dotyczące licencji
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_pl" title="Poziomy emisji hałasu">
      Poziomy emisji hałasu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_pl" title="Dyrektywa WEEE dotycząca zużytego sprzętu elektrycznego i elektronicznego">
      Dyrektywa WEEE dotycząca zużytego sprzętu elektrycznego i elektronicznego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14265" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_pl" title="Wyrzucanie produkt&oacute;w">
      Wyrzucanie produkt&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14299" title="Akumulator litowo-jonowy">
      Akumulator litowo-jonowy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_pl" title="Rozporządzenie (UE) 2023/1542">
      Rozporządzenie (UE) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_pl" title="Zwrot kaset firmy Lexmark w celu ponownego użycia lub recyklingu">
      Zwrot kaset firmy Lexmark w celu ponownego użycia lub recyklingu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_pl" title="Ostrzeżenie o podatności na ładunki elektrostatyczne">
      Ostrzeżenie o podatności na ładunki elektrostatyczne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_pl" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_pl" title="Informacje o temperaturze">
      Informacje o temperaturze
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_pl" title="Oświadczenie dotyczące lasera">
      Oświadczenie dotyczące lasera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_pl" title="Zużycie energii">
      Zużycie energii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14550" title="Uwagi dotyczące przepis&oacute;w związanych z produktami bezprzewodowymi">
      Uwagi dotyczące przepis&oacute;w związanych z produktami bezprzewodowymi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_pl" title="Uwagi dotyczące składnika modułowego">
      Uwagi dotyczące składnika modułowego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_pl" title="Zagrożenie promieniowaniem o częstotliwości radiowej">
      Zagrożenie promieniowaniem o częstotliwości radiowej
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14576" title="Zgodność z dyrektywami Wsp&oacute;lnoty Europejskiej">
      Zgodność z dyrektywami Wsp&oacute;lnoty Europejskiej
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_pl" title="Zgodność z dyrektywami Wsp&oacute;lnoty Europejskiej">
      Zgodność z dyrektywami Wsp&oacute;lnoty Europejskiej
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue